import { defaultTo, map, propOr } from 'ramda';
import buildROIntervalsWithTabsAndFranchise from '../../helpers/buildROIntervalsWithTabsAndFranchise.js';
import { calculateHealthInsurancesWithFranchise } from './applyFranchiseToIntervals.js';
import { calculateDailyBaseAmount } from './intervalsHelpers.js';

export const buildIncapFranchiseData = ({
  franchiseValue,
  guarantees,
  pricesGuarantees,
  getMiddleBoolean,
  incapCapValue,
  annualIncome,
  PASS
}) => {
  const franchiseROData = buildROIntervalsWithTabsAndFranchise({
    guarantees,
    pricesGuarantees,
    getMiddleBoolean,
    configPrefix: 'NIVEAUXGARANTIESETTARIFS_GAR_INCAP',
    franchise: franchiseValue
  });

  const percentage = defaultTo(0, parseFloat(incapCapValue));
  const baseAmount = calculateDailyBaseAmount(annualIncome, percentage);

  const franchiseHealthInsurances = calculateHealthInsurancesWithFranchise(
    propOr([], 'intervals', franchiseROData),
    propOr([], 'ROs', franchiseROData),
    baseAmount,
    annualIncome > PASS,
    franchiseValue
  );

  return {
    healthInsurances: map(String, franchiseHealthInsurances),
    ROs: propOr([], 'ROs', franchiseROData),
    labelsRO: propOr([], 'labels', franchiseROData)
  };
};
